import React, { useState, useEffect } from 'react';
import './Faq.css';
import { useLanguage } from './LanguageContext'; // Dil context'ini import ediyoruz

// Akordiyon elemanını oluşturan alt component (değişiklik yok)
const FaqItem = ({ faq, index, toggleFAQ }) => {
  return (
    <div
      className={"faq " + (faq.open ? 'open' : '')}
      key={index}
      onClick={() => toggleFAQ(index)}
    >
      <div className="faq-question">
        {faq.question}
      </div>
      <div className="faq-answer">
        {faq.answer}
      </div>
    </div>
  );
};

// Ana SSS component'i (GÜNCELLENDİ)
function Faq() {
  const { language, translations } = useLanguage(); // Seçili dili ve çevirileri alıyoruz
  
  // Dil değiştiğinde SSS verisini güncelleyecek state
  const [faqs, setFaqs] = useState([]);

  // Dil veya çeviriler değiştiğinde, SSS listesini yeniden oluşturuyoruz
  useEffect(() => {
    // Mevcut dilin SSS verisini alıp, hepsini kapalı olarak ayarlıyoruz
    const currentFaqs = translations[language].faqs || [];
    setFaqs(currentFaqs.map(item => ({ ...item, open: false })));
  }, [language, translations]); // Bu effect, dil değiştiğinde çalışır

  const toggleFAQ = index => {
    setFaqs(
      faqs.map((faq, i) => {
        if (i === index) {
          faq.open = !faq.open;
        } else {
          faq.open = false;
        }
        return faq;
      })
    );
  };

  // Eğer o dil için SSS verisi yoksa, bölümü hiç gösterme
  if (!faqs.length) {
    return null;
  }

  return (
    <div className="faq-section" id="faq">
      <div className="section-container">
        <h1 data-subtitle={translations[language].faqSubtitle || "MERAK ETTİKLERİNİZ"}>
          {translations[language].faqTitle || "Sıkça Sorulan Sorular"}
        </h1>
        <div className="faqs">
          {faqs.map((faq, i) => (
            <FaqItem faq={faq} index={i} key={i} toggleFAQ={toggleFAQ} />
          ))}
        </div>
      </div>
    </div>
  );
}

export default Faq;
